import TablePage from '@/found/components/table_page';
import { ProcessLog } from '@/found/modules';
import Form from './form/index';

export default {
  name: 'terminal_order',
  extends: TablePage,
  data() {
    return {};
  },
  components: {
    Form,
    ProcessLog,
  },
  created() {
    this.getConfigList('terminal_order_list');
  },
  methods: {
    clickVisible({ row, val: { code } }) {
      const { processCode } = row;
      if (code === 'process_log' && !processCode) {
        return false;
      }
      return true;
    },
    modalClick({ val, row }) {
      console.log(val);
      if (val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      }
      if (val.code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row: { processNo: row.processCode },
        };

        this.modalConfig.title = '流程日志';

        this.formName = 'ProcessLog';
        this.openDrawer();
      }
    },
  },
};
